/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TokenLoginRouteImport } from './routes/token-login'
import { Route as DevRouteImport } from './routes/dev'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TokenloginIndexRouteImport } from './routes/tokenlogin/index'
import { Route as LoginIndexRouteImport } from './routes/login/index'
import { Route as DevIndexRouteImport } from './routes/dev/index'
import { Route as LoginCompleteRouteImport } from './routes/login/complete'
import { Route as DevTasksRouteImport } from './routes/dev/Tasks'
import { Route as DevOttoPilotRouteImport } from './routes/dev/OttoPilot'
import { Route as DevFormsRouteImport } from './routes/dev/Forms'
import { Route as DevAppointmentsRouteImport } from './routes/dev/Appointments'
import { Route as AcceptInvitationCodeRouteImport } from './routes/accept-invitation.$code'
import { Route as AuthenticatedRadarRouteImport } from './routes/_authenticated/radar'
import { Route as AuthenticatedHomeRouteImport } from './routes/_authenticated/home'
import { Route as AuthenticatedSettingsRouteRouteImport } from './routes/_authenticated/settings/route'
import { Route as DevOttoPilotIndexRouteImport } from './routes/dev/OttoPilot/index'
import { Route as AuthenticatedTasksIndexRouteImport } from './routes/_authenticated/tasks/index'
import { Route as AuthenticatedSettingsIndexRouteImport } from './routes/_authenticated/settings/index'
import { Route as AuthenticatedReportingIndexRouteImport } from './routes/_authenticated/reporting/index'
import { Route as AuthenticatedProgramsIndexRouteImport } from './routes/_authenticated/programs/index'
import { Route as AuthenticatedPilotIndexRouteImport } from './routes/_authenticated/pilot/index'
import { Route as DevOttoPilotChatIdRouteImport } from './routes/dev/OttoPilot/$chatId'
import { Route as AuthenticatedUpgradeTeamChatRouteImport } from './routes/_authenticated/upgrade/team-chat'
import { Route as AuthenticatedUpgradeConversationsRouteImport } from './routes/_authenticated/upgrade/conversations'
import { Route as AuthenticatedUpgradeBoardRouteImport } from './routes/_authenticated/upgrade/board'
import { Route as AuthenticatedReportingSplatRouteImport } from './routes/_authenticated/reporting/$'
import { Route as AuthenticatedProgramsSplatRouteImport } from './routes/_authenticated/programs/$'
import { Route as AuthenticatedPilotSplatRouteImport } from './routes/_authenticated/pilot/$'
import { Route as AuthenticatedSettingsTasksIndexRouteImport } from './routes/_authenticated/settings/tasks/index'
import { Route as AuthenticatedSettingsNotificationsIndexRouteImport } from './routes/_authenticated/settings/notifications/index'

const TokenLoginRoute = TokenLoginRouteImport.update({
  id: '/token-login',
  path: '/token-login',
  getParentRoute: () => rootRouteImport,
} as any)
const DevRoute = DevRouteImport.update({
  id: '/dev',
  path: '/dev',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TokenloginIndexRoute = TokenloginIndexRouteImport.update({
  id: '/tokenlogin/',
  path: '/tokenlogin/',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginIndexRoute = LoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => rootRouteImport,
} as any)
const DevIndexRoute = DevIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DevRoute,
} as any)
const LoginCompleteRoute = LoginCompleteRouteImport.update({
  id: '/login/complete',
  path: '/login/complete',
  getParentRoute: () => rootRouteImport,
} as any)
const DevTasksRoute = DevTasksRouteImport.update({
  id: '/Tasks',
  path: '/Tasks',
  getParentRoute: () => DevRoute,
} as any)
const DevOttoPilotRoute = DevOttoPilotRouteImport.update({
  id: '/OttoPilot',
  path: '/OttoPilot',
  getParentRoute: () => DevRoute,
} as any)
const DevFormsRoute = DevFormsRouteImport.update({
  id: '/Forms',
  path: '/Forms',
  getParentRoute: () => DevRoute,
} as any)
const DevAppointmentsRoute = DevAppointmentsRouteImport.update({
  id: '/Appointments',
  path: '/Appointments',
  getParentRoute: () => DevRoute,
} as any)
const AcceptInvitationCodeRoute = AcceptInvitationCodeRouteImport.update({
  id: '/accept-invitation/$code',
  path: '/accept-invitation/$code',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRadarRoute = AuthenticatedRadarRouteImport.update({
  id: '/radar',
  path: '/radar',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedHomeRoute = AuthenticatedHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedSettingsRouteRoute =
  AuthenticatedSettingsRouteRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const DevOttoPilotIndexRoute = DevOttoPilotIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DevOttoPilotRoute,
} as any)
const AuthenticatedTasksIndexRoute = AuthenticatedTasksIndexRouteImport.update({
  id: '/tasks/',
  path: '/tasks/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedSettingsIndexRoute =
  AuthenticatedSettingsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedReportingIndexRoute =
  AuthenticatedReportingIndexRouteImport.update({
    id: '/reporting/',
    path: '/reporting/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProgramsIndexRoute =
  AuthenticatedProgramsIndexRouteImport.update({
    id: '/programs/',
    path: '/programs/',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPilotIndexRoute = AuthenticatedPilotIndexRouteImport.update({
  id: '/pilot/',
  path: '/pilot/',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const DevOttoPilotChatIdRoute = DevOttoPilotChatIdRouteImport.update({
  id: '/$chatId',
  path: '/$chatId',
  getParentRoute: () => DevOttoPilotRoute,
} as any)
const AuthenticatedUpgradeTeamChatRoute =
  AuthenticatedUpgradeTeamChatRouteImport.update({
    id: '/upgrade/team-chat',
    path: '/upgrade/team-chat',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedUpgradeConversationsRoute =
  AuthenticatedUpgradeConversationsRouteImport.update({
    id: '/upgrade/conversations',
    path: '/upgrade/conversations',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedUpgradeBoardRoute =
  AuthenticatedUpgradeBoardRouteImport.update({
    id: '/upgrade/board',
    path: '/upgrade/board',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedReportingSplatRoute =
  AuthenticatedReportingSplatRouteImport.update({
    id: '/reporting/$',
    path: '/reporting/$',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedProgramsSplatRoute =
  AuthenticatedProgramsSplatRouteImport.update({
    id: '/programs/$',
    path: '/programs/$',
    getParentRoute: () => AuthenticatedRouteRoute,
  } as any)
const AuthenticatedPilotSplatRoute = AuthenticatedPilotSplatRouteImport.update({
  id: '/pilot/$',
  path: '/pilot/$',
  getParentRoute: () => AuthenticatedRouteRoute,
} as any)
const AuthenticatedSettingsTasksIndexRoute =
  AuthenticatedSettingsTasksIndexRouteImport.update({
    id: '/tasks/',
    path: '/tasks/',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)
const AuthenticatedSettingsNotificationsIndexRoute =
  AuthenticatedSettingsNotificationsIndexRouteImport.update({
    id: '/notifications/',
    path: '/notifications/',
    getParentRoute: () => AuthenticatedSettingsRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/dev': typeof DevRouteWithChildren
  '/token-login': typeof TokenLoginRoute
  '/settings': typeof AuthenticatedSettingsRouteRouteWithChildren
  '/home': typeof AuthenticatedHomeRoute
  '/radar': typeof AuthenticatedRadarRoute
  '/accept-invitation/$code': typeof AcceptInvitationCodeRoute
  '/dev/Appointments': typeof DevAppointmentsRoute
  '/dev/Forms': typeof DevFormsRoute
  '/dev/OttoPilot': typeof DevOttoPilotRouteWithChildren
  '/dev/Tasks': typeof DevTasksRoute
  '/login/complete': typeof LoginCompleteRoute
  '/dev/': typeof DevIndexRoute
  '/login/': typeof LoginIndexRoute
  '/tokenlogin/': typeof TokenloginIndexRoute
  '/pilot/$': typeof AuthenticatedPilotSplatRoute
  '/programs/$': typeof AuthenticatedProgramsSplatRoute
  '/reporting/$': typeof AuthenticatedReportingSplatRoute
  '/upgrade/board': typeof AuthenticatedUpgradeBoardRoute
  '/upgrade/conversations': typeof AuthenticatedUpgradeConversationsRoute
  '/upgrade/team-chat': typeof AuthenticatedUpgradeTeamChatRoute
  '/dev/OttoPilot/$chatId': typeof DevOttoPilotChatIdRoute
  '/pilot/': typeof AuthenticatedPilotIndexRoute
  '/programs/': typeof AuthenticatedProgramsIndexRoute
  '/reporting/': typeof AuthenticatedReportingIndexRoute
  '/settings/': typeof AuthenticatedSettingsIndexRoute
  '/tasks/': typeof AuthenticatedTasksIndexRoute
  '/dev/OttoPilot/': typeof DevOttoPilotIndexRoute
  '/settings/notifications/': typeof AuthenticatedSettingsNotificationsIndexRoute
  '/settings/tasks/': typeof AuthenticatedSettingsTasksIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/token-login': typeof TokenLoginRoute
  '/home': typeof AuthenticatedHomeRoute
  '/radar': typeof AuthenticatedRadarRoute
  '/accept-invitation/$code': typeof AcceptInvitationCodeRoute
  '/dev/Appointments': typeof DevAppointmentsRoute
  '/dev/Forms': typeof DevFormsRoute
  '/dev/Tasks': typeof DevTasksRoute
  '/login/complete': typeof LoginCompleteRoute
  '/dev': typeof DevIndexRoute
  '/login': typeof LoginIndexRoute
  '/tokenlogin': typeof TokenloginIndexRoute
  '/pilot/$': typeof AuthenticatedPilotSplatRoute
  '/programs/$': typeof AuthenticatedProgramsSplatRoute
  '/reporting/$': typeof AuthenticatedReportingSplatRoute
  '/upgrade/board': typeof AuthenticatedUpgradeBoardRoute
  '/upgrade/conversations': typeof AuthenticatedUpgradeConversationsRoute
  '/upgrade/team-chat': typeof AuthenticatedUpgradeTeamChatRoute
  '/dev/OttoPilot/$chatId': typeof DevOttoPilotChatIdRoute
  '/pilot': typeof AuthenticatedPilotIndexRoute
  '/programs': typeof AuthenticatedProgramsIndexRoute
  '/reporting': typeof AuthenticatedReportingIndexRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
  '/tasks': typeof AuthenticatedTasksIndexRoute
  '/dev/OttoPilot': typeof DevOttoPilotIndexRoute
  '/settings/notifications': typeof AuthenticatedSettingsNotificationsIndexRoute
  '/settings/tasks': typeof AuthenticatedSettingsTasksIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteRouteWithChildren
  '/dev': typeof DevRouteWithChildren
  '/token-login': typeof TokenLoginRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRouteRouteWithChildren
  '/_authenticated/home': typeof AuthenticatedHomeRoute
  '/_authenticated/radar': typeof AuthenticatedRadarRoute
  '/accept-invitation/$code': typeof AcceptInvitationCodeRoute
  '/dev/Appointments': typeof DevAppointmentsRoute
  '/dev/Forms': typeof DevFormsRoute
  '/dev/OttoPilot': typeof DevOttoPilotRouteWithChildren
  '/dev/Tasks': typeof DevTasksRoute
  '/login/complete': typeof LoginCompleteRoute
  '/dev/': typeof DevIndexRoute
  '/login/': typeof LoginIndexRoute
  '/tokenlogin/': typeof TokenloginIndexRoute
  '/_authenticated/pilot/$': typeof AuthenticatedPilotSplatRoute
  '/_authenticated/programs/$': typeof AuthenticatedProgramsSplatRoute
  '/_authenticated/reporting/$': typeof AuthenticatedReportingSplatRoute
  '/_authenticated/upgrade/board': typeof AuthenticatedUpgradeBoardRoute
  '/_authenticated/upgrade/conversations': typeof AuthenticatedUpgradeConversationsRoute
  '/_authenticated/upgrade/team-chat': typeof AuthenticatedUpgradeTeamChatRoute
  '/dev/OttoPilot/$chatId': typeof DevOttoPilotChatIdRoute
  '/_authenticated/pilot/': typeof AuthenticatedPilotIndexRoute
  '/_authenticated/programs/': typeof AuthenticatedProgramsIndexRoute
  '/_authenticated/reporting/': typeof AuthenticatedReportingIndexRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
  '/_authenticated/tasks/': typeof AuthenticatedTasksIndexRoute
  '/dev/OttoPilot/': typeof DevOttoPilotIndexRoute
  '/_authenticated/settings/notifications/': typeof AuthenticatedSettingsNotificationsIndexRoute
  '/_authenticated/settings/tasks/': typeof AuthenticatedSettingsTasksIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dev'
    | '/token-login'
    | '/settings'
    | '/home'
    | '/radar'
    | '/accept-invitation/$code'
    | '/dev/Appointments'
    | '/dev/Forms'
    | '/dev/OttoPilot'
    | '/dev/Tasks'
    | '/login/complete'
    | '/dev/'
    | '/login/'
    | '/tokenlogin/'
    | '/pilot/$'
    | '/programs/$'
    | '/reporting/$'
    | '/upgrade/board'
    | '/upgrade/conversations'
    | '/upgrade/team-chat'
    | '/dev/OttoPilot/$chatId'
    | '/pilot/'
    | '/programs/'
    | '/reporting/'
    | '/settings/'
    | '/tasks/'
    | '/dev/OttoPilot/'
    | '/settings/notifications/'
    | '/settings/tasks/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/token-login'
    | '/home'
    | '/radar'
    | '/accept-invitation/$code'
    | '/dev/Appointments'
    | '/dev/Forms'
    | '/dev/Tasks'
    | '/login/complete'
    | '/dev'
    | '/login'
    | '/tokenlogin'
    | '/pilot/$'
    | '/programs/$'
    | '/reporting/$'
    | '/upgrade/board'
    | '/upgrade/conversations'
    | '/upgrade/team-chat'
    | '/dev/OttoPilot/$chatId'
    | '/pilot'
    | '/programs'
    | '/reporting'
    | '/settings'
    | '/tasks'
    | '/dev/OttoPilot'
    | '/settings/notifications'
    | '/settings/tasks'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/dev'
    | '/token-login'
    | '/_authenticated/settings'
    | '/_authenticated/home'
    | '/_authenticated/radar'
    | '/accept-invitation/$code'
    | '/dev/Appointments'
    | '/dev/Forms'
    | '/dev/OttoPilot'
    | '/dev/Tasks'
    | '/login/complete'
    | '/dev/'
    | '/login/'
    | '/tokenlogin/'
    | '/_authenticated/pilot/$'
    | '/_authenticated/programs/$'
    | '/_authenticated/reporting/$'
    | '/_authenticated/upgrade/board'
    | '/_authenticated/upgrade/conversations'
    | '/_authenticated/upgrade/team-chat'
    | '/dev/OttoPilot/$chatId'
    | '/_authenticated/pilot/'
    | '/_authenticated/programs/'
    | '/_authenticated/reporting/'
    | '/_authenticated/settings/'
    | '/_authenticated/tasks/'
    | '/dev/OttoPilot/'
    | '/_authenticated/settings/notifications/'
    | '/_authenticated/settings/tasks/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRouteRoute: typeof AuthenticatedRouteRouteWithChildren
  DevRoute: typeof DevRouteWithChildren
  TokenLoginRoute: typeof TokenLoginRoute
  AcceptInvitationCodeRoute: typeof AcceptInvitationCodeRoute
  LoginCompleteRoute: typeof LoginCompleteRoute
  LoginIndexRoute: typeof LoginIndexRoute
  TokenloginIndexRoute: typeof TokenloginIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/token-login': {
      id: '/token-login'
      path: '/token-login'
      fullPath: '/token-login'
      preLoaderRoute: typeof TokenLoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev': {
      id: '/dev'
      path: '/dev'
      fullPath: '/dev'
      preLoaderRoute: typeof DevRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tokenlogin/': {
      id: '/tokenlogin/'
      path: '/tokenlogin'
      fullPath: '/tokenlogin/'
      preLoaderRoute: typeof TokenloginIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login/': {
      id: '/login/'
      path: '/login'
      fullPath: '/login/'
      preLoaderRoute: typeof LoginIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/': {
      id: '/dev/'
      path: '/'
      fullPath: '/dev/'
      preLoaderRoute: typeof DevIndexRouteImport
      parentRoute: typeof DevRoute
    }
    '/login/complete': {
      id: '/login/complete'
      path: '/login/complete'
      fullPath: '/login/complete'
      preLoaderRoute: typeof LoginCompleteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/Tasks': {
      id: '/dev/Tasks'
      path: '/Tasks'
      fullPath: '/dev/Tasks'
      preLoaderRoute: typeof DevTasksRouteImport
      parentRoute: typeof DevRoute
    }
    '/dev/OttoPilot': {
      id: '/dev/OttoPilot'
      path: '/OttoPilot'
      fullPath: '/dev/OttoPilot'
      preLoaderRoute: typeof DevOttoPilotRouteImport
      parentRoute: typeof DevRoute
    }
    '/dev/Forms': {
      id: '/dev/Forms'
      path: '/Forms'
      fullPath: '/dev/Forms'
      preLoaderRoute: typeof DevFormsRouteImport
      parentRoute: typeof DevRoute
    }
    '/dev/Appointments': {
      id: '/dev/Appointments'
      path: '/Appointments'
      fullPath: '/dev/Appointments'
      preLoaderRoute: typeof DevAppointmentsRouteImport
      parentRoute: typeof DevRoute
    }
    '/accept-invitation/$code': {
      id: '/accept-invitation/$code'
      path: '/accept-invitation/$code'
      fullPath: '/accept-invitation/$code'
      preLoaderRoute: typeof AcceptInvitationCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/radar': {
      id: '/_authenticated/radar'
      path: '/radar'
      fullPath: '/radar'
      preLoaderRoute: typeof AuthenticatedRadarRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/home': {
      id: '/_authenticated/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AuthenticatedHomeRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/dev/OttoPilot/': {
      id: '/dev/OttoPilot/'
      path: '/'
      fullPath: '/dev/OttoPilot/'
      preLoaderRoute: typeof DevOttoPilotIndexRouteImport
      parentRoute: typeof DevOttoPilotRoute
    }
    '/_authenticated/tasks/': {
      id: '/_authenticated/tasks/'
      path: '/tasks'
      fullPath: '/tasks/'
      preLoaderRoute: typeof AuthenticatedTasksIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/reporting/': {
      id: '/_authenticated/reporting/'
      path: '/reporting'
      fullPath: '/reporting/'
      preLoaderRoute: typeof AuthenticatedReportingIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/programs/': {
      id: '/_authenticated/programs/'
      path: '/programs'
      fullPath: '/programs/'
      preLoaderRoute: typeof AuthenticatedProgramsIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/pilot/': {
      id: '/_authenticated/pilot/'
      path: '/pilot'
      fullPath: '/pilot/'
      preLoaderRoute: typeof AuthenticatedPilotIndexRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/dev/OttoPilot/$chatId': {
      id: '/dev/OttoPilot/$chatId'
      path: '/$chatId'
      fullPath: '/dev/OttoPilot/$chatId'
      preLoaderRoute: typeof DevOttoPilotChatIdRouteImport
      parentRoute: typeof DevOttoPilotRoute
    }
    '/_authenticated/upgrade/team-chat': {
      id: '/_authenticated/upgrade/team-chat'
      path: '/upgrade/team-chat'
      fullPath: '/upgrade/team-chat'
      preLoaderRoute: typeof AuthenticatedUpgradeTeamChatRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/upgrade/conversations': {
      id: '/_authenticated/upgrade/conversations'
      path: '/upgrade/conversations'
      fullPath: '/upgrade/conversations'
      preLoaderRoute: typeof AuthenticatedUpgradeConversationsRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/upgrade/board': {
      id: '/_authenticated/upgrade/board'
      path: '/upgrade/board'
      fullPath: '/upgrade/board'
      preLoaderRoute: typeof AuthenticatedUpgradeBoardRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/reporting/$': {
      id: '/_authenticated/reporting/$'
      path: '/reporting/$'
      fullPath: '/reporting/$'
      preLoaderRoute: typeof AuthenticatedReportingSplatRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/programs/$': {
      id: '/_authenticated/programs/$'
      path: '/programs/$'
      fullPath: '/programs/$'
      preLoaderRoute: typeof AuthenticatedProgramsSplatRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/pilot/$': {
      id: '/_authenticated/pilot/$'
      path: '/pilot/$'
      fullPath: '/pilot/$'
      preLoaderRoute: typeof AuthenticatedPilotSplatRouteImport
      parentRoute: typeof AuthenticatedRouteRoute
    }
    '/_authenticated/settings/tasks/': {
      id: '/_authenticated/settings/tasks/'
      path: '/tasks'
      fullPath: '/settings/tasks/'
      preLoaderRoute: typeof AuthenticatedSettingsTasksIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
    '/_authenticated/settings/notifications/': {
      id: '/_authenticated/settings/notifications/'
      path: '/notifications'
      fullPath: '/settings/notifications/'
      preLoaderRoute: typeof AuthenticatedSettingsNotificationsIndexRouteImport
      parentRoute: typeof AuthenticatedSettingsRouteRoute
    }
  }
}

interface AuthenticatedSettingsRouteRouteChildren {
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
  AuthenticatedSettingsNotificationsIndexRoute: typeof AuthenticatedSettingsNotificationsIndexRoute
  AuthenticatedSettingsTasksIndexRoute: typeof AuthenticatedSettingsTasksIndexRoute
}

const AuthenticatedSettingsRouteRouteChildren: AuthenticatedSettingsRouteRouteChildren =
  {
    AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
    AuthenticatedSettingsNotificationsIndexRoute:
      AuthenticatedSettingsNotificationsIndexRoute,
    AuthenticatedSettingsTasksIndexRoute: AuthenticatedSettingsTasksIndexRoute,
  }

const AuthenticatedSettingsRouteRouteWithChildren =
  AuthenticatedSettingsRouteRoute._addFileChildren(
    AuthenticatedSettingsRouteRouteChildren,
  )

interface AuthenticatedRouteRouteChildren {
  AuthenticatedSettingsRouteRoute: typeof AuthenticatedSettingsRouteRouteWithChildren
  AuthenticatedHomeRoute: typeof AuthenticatedHomeRoute
  AuthenticatedRadarRoute: typeof AuthenticatedRadarRoute
  AuthenticatedPilotSplatRoute: typeof AuthenticatedPilotSplatRoute
  AuthenticatedProgramsSplatRoute: typeof AuthenticatedProgramsSplatRoute
  AuthenticatedReportingSplatRoute: typeof AuthenticatedReportingSplatRoute
  AuthenticatedUpgradeBoardRoute: typeof AuthenticatedUpgradeBoardRoute
  AuthenticatedUpgradeConversationsRoute: typeof AuthenticatedUpgradeConversationsRoute
  AuthenticatedUpgradeTeamChatRoute: typeof AuthenticatedUpgradeTeamChatRoute
  AuthenticatedPilotIndexRoute: typeof AuthenticatedPilotIndexRoute
  AuthenticatedProgramsIndexRoute: typeof AuthenticatedProgramsIndexRoute
  AuthenticatedReportingIndexRoute: typeof AuthenticatedReportingIndexRoute
  AuthenticatedTasksIndexRoute: typeof AuthenticatedTasksIndexRoute
}

const AuthenticatedRouteRouteChildren: AuthenticatedRouteRouteChildren = {
  AuthenticatedSettingsRouteRoute: AuthenticatedSettingsRouteRouteWithChildren,
  AuthenticatedHomeRoute: AuthenticatedHomeRoute,
  AuthenticatedRadarRoute: AuthenticatedRadarRoute,
  AuthenticatedPilotSplatRoute: AuthenticatedPilotSplatRoute,
  AuthenticatedProgramsSplatRoute: AuthenticatedProgramsSplatRoute,
  AuthenticatedReportingSplatRoute: AuthenticatedReportingSplatRoute,
  AuthenticatedUpgradeBoardRoute: AuthenticatedUpgradeBoardRoute,
  AuthenticatedUpgradeConversationsRoute:
    AuthenticatedUpgradeConversationsRoute,
  AuthenticatedUpgradeTeamChatRoute: AuthenticatedUpgradeTeamChatRoute,
  AuthenticatedPilotIndexRoute: AuthenticatedPilotIndexRoute,
  AuthenticatedProgramsIndexRoute: AuthenticatedProgramsIndexRoute,
  AuthenticatedReportingIndexRoute: AuthenticatedReportingIndexRoute,
  AuthenticatedTasksIndexRoute: AuthenticatedTasksIndexRoute,
}

const AuthenticatedRouteRouteWithChildren =
  AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

interface DevOttoPilotRouteChildren {
  DevOttoPilotChatIdRoute: typeof DevOttoPilotChatIdRoute
  DevOttoPilotIndexRoute: typeof DevOttoPilotIndexRoute
}

const DevOttoPilotRouteChildren: DevOttoPilotRouteChildren = {
  DevOttoPilotChatIdRoute: DevOttoPilotChatIdRoute,
  DevOttoPilotIndexRoute: DevOttoPilotIndexRoute,
}

const DevOttoPilotRouteWithChildren = DevOttoPilotRoute._addFileChildren(
  DevOttoPilotRouteChildren,
)

interface DevRouteChildren {
  DevAppointmentsRoute: typeof DevAppointmentsRoute
  DevFormsRoute: typeof DevFormsRoute
  DevOttoPilotRoute: typeof DevOttoPilotRouteWithChildren
  DevTasksRoute: typeof DevTasksRoute
  DevIndexRoute: typeof DevIndexRoute
}

const DevRouteChildren: DevRouteChildren = {
  DevAppointmentsRoute: DevAppointmentsRoute,
  DevFormsRoute: DevFormsRoute,
  DevOttoPilotRoute: DevOttoPilotRouteWithChildren,
  DevTasksRoute: DevTasksRoute,
  DevIndexRoute: DevIndexRoute,
}

const DevRouteWithChildren = DevRoute._addFileChildren(DevRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,
  DevRoute: DevRouteWithChildren,
  TokenLoginRoute: TokenLoginRoute,
  AcceptInvitationCodeRoute: AcceptInvitationCodeRoute,
  LoginCompleteRoute: LoginCompleteRoute,
  LoginIndexRoute: LoginIndexRoute,
  TokenloginIndexRoute: TokenloginIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
